<template lang="pug">
    v-dialog(v-model='dialog' max-higth='500px' persistent)
      template(v-slot:activator='{ on }')
        v-btn(color='secondary' icon v-on='on' @click='ver_propuestas(idCotizacion)')
          v-icon(small) far fa-eye
      v-card
        v-container.py-5
          h1.mb-3 Informe de cotizaciones
          p Se han recibido las siguientes propuestas:
          v-data-table.elevation-4.my-5( :headers='encabezados_con_proveedor' :footer-props="footerProps" hide-default-footer :items='Propuestas' item-key='numeracion' )
            template( v-slot:item="{ item }")
              tr
                td {{item.numeracion}}
                td {{item.descripcion}}
                td {{item.cantidad}}
                template( v-for='proveedor, p of Proveedores' ) 
                  td 
                    span(v-if='item[proveedor] && typeof item[proveedor] === "number" || (typeof item[proveedor] === "string" && !item[proveedor].includes("http"))') {{item[proveedor]}}
                    v-btn(v-if='item[proveedor] && typeof item[proveedor] === "string" && item[proveedor].includes("http")' :href='item[proveedor]' target='_blank' color='primary' icon) 
                      v-icon fa-download

          v-row(justify='center')
            v-spacer
            v-dialog(v-model='provedor_dialog' scrollable max-width='400px')
              template(v-slot:activator='{ on }')
                v-btn(color='primary' dark v-on='on' :disabled ='Datos.estado_del_documento == "proveedor_seleccionado"'  ) Seleccione proveedor
                v-btn(color='primary' dark  @click='dialog=false'  ) Cerrar
              v-card
                v-card-title Elige a tu proveedor
                v-divider
                v-card-text(style='height: 300px;') 
                  v-radio-group(v-model='Datos.proveedor_seleccionado' column=''  )
                    v-radio( v-for='proveedor, index in Proveedor_seleccionado' :key='index' :value='proveedor' :label='proveedor.proveedor.name') 
                v-divider
                v-card-actions
                  v-btn(color='blue darken-1' text @click='dialog=false;') Cerrar
                  v-btn(color='blue darken-1' text @click='generar_compra({datos:Datos.proveedor_seleccionado,idCotizacion}),dialog=false') Guardar
</template>
<script>
import {db} from '@/FirebaseConfig'
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
    data: () => ({
        dialog:false,
        provedor_dialog: false,
        archivos_dialog: false,
        headers: [
            { text: 'Nº', value: 'numeracion'},
            { text: 'Lista de productos',  value: 'descripcion' },
            { text: 'Cantidad',  value: 'cantidad' },
        ],
         footerProps: {
          'items-per-page-options':  [-1]
        },
    }),
    props:{
        idCotizacion:String,
    },
  
    methods:{
      ...mapActions({
        generar_compra: 'Ordenes_de_compra/add',
        ver_propuestas: 'Cotizaciones/ver_propuestas',
      }),
      async ver_propuestas (idCotizacion) {
        await this.$store.dispatch('Cotizaciones/ver_propuestas', idCotizacion) 
        this.dialog = true
      },
    },

    computed:{
      encabezados_con_proveedor(){
        const headers_copy = [...this.headers]
        this.Proveedores.map(item => headers_copy.push({text: item, value: item}))
        return headers_copy
      },
      ...mapGetters({
        Propuestas: 'Cotizaciones/propuestas',
        Proveedores:'Cotizaciones/proveedores',
        Proveedor_seleccionado: 'Cotizaciones/registro_de_propuestas'
      }),
      ...mapState({
        Datos: state=> state.Cotizaciones.datos,
        Cotizaciones :state=> state.Cotizaciones,
      })
    }
}

</script>